// The two width breakpoints and the hover capability query.
//
// These MIRROR the media queries in public/style.css by hand — the JS needs to
// know which tier it is in (the month labels that fit the timeline, the chart
// viewBox, where the chrome is parented) and there is no way to ask the
// stylesheet. lib/dom-contract.test.ts is the guard against them drifting apart.
//
// Hover is a DEVICE capability, not a width: a small window on a desktop still
// hovers, and a large tablet still does not. Gating hover affordances on width
// is the mistake this query exists to prevent.

// One mobile breakpoint, mirrored by hand from the one phone block in style.css —
// including its second term, which is a phone held SIDEWAYS. A 15 Pro in landscape
// is 852px wide, so on width alone a rotated phone gets the compact-desktop tier;
// what actually distinguishes the two is a touch device with a short screen (every
// phone in landscape is under 440px tall, the smallest tablet is 744).
export const MOBILE = window.matchMedia(
  '(max-width: 720px), (hover: none) and (pointer: coarse) and (max-height: 520px)',
);
// The compact-desktop band (721–1180px), between the phone layout and the width
// the multi-column diagram grid needs (>1180). Mirrors the CSS tier of the same
// range and the existing single-column diagram breakpoint. Drives two things: the
// short month labels (Jan/Feb…) that fit the narrower timeline, and the temp
// chart drawing at its narrow single-column viewBox instead of the wide desktop
// one (see renderCity).
export const TABLET = window.matchMedia('(min-width: 721px) and (max-width: 1180px)');
export const NO_HOVER = window.matchMedia('(hover: none)');
// Also a capability rather than a width: a reader who has asked the system for
// less motion gets the ruler's marker stepping dekad to dekad instead of
// sweeping, and the briefing's rise turned off (that one is CSS's own @media).
export const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
